/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FieldItemDtoFromJSON, FieldItemDtoToJSON, } from './FieldItemDto';
import { FieldValidationDtoFromJSON, FieldValidationDtoToJSON, } from './FieldValidationDto';
/**
 * @export
 */
export const FieldGroupDtoFieldTypeEnum = {
    InputText: 'INPUT_TEXT',
    InputNumber: 'INPUT_NUMBER',
    CodiceSeriale: 'CODICE_SERIALE',
    InputFile: 'INPUT_FILE',
    Checklist: 'CHECKLIST',
    Radiolist: 'RADIOLIST',
    Checkbox: 'CHECKBOX',
    Radiobox: 'RADIOBOX'
};
/**
 * Check if a given object implements the FieldGroupDto interface.
 */
export function instanceOfFieldGroupDto(value) {
    let isInstance = true;
    return isInstance;
}
export function FieldGroupDtoFromJSON(json) {
    return FieldGroupDtoFromJSONTyped(json, false);
}
export function FieldGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fieldType': !exists(json, 'fieldType') ? undefined : json['fieldType'],
        'items': !exists(json, 'items') ? undefined : (json['items'].map(FieldItemDtoFromJSON)),
        'validation': !exists(json, 'validation') ? undefined : FieldValidationDtoFromJSON(json['validation']),
    };
}
export function FieldGroupDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fieldType': value.fieldType,
        'items': value.items === undefined ? undefined : (value.items.map(FieldItemDtoToJSON)),
        'validation': FieldValidationDtoToJSON(value.validation),
    };
}
